module.exports = __webpack_public_path__ + "img/logo.f5e45918.svg";